import style from '../Home.module.scss';
import {memo, useState, useCallback, useEffect} from "react";
import className from 'classnames/bind';
import {
	CardMoney,
	ContentHeader,
	SidebarAccount,
	TrainingScheduleWeek,
	DashboardWidgetHeader,
	EvaluationFailedWidget,
	ExpiringListWidget,
} from "../componets";
import {Col, Row, Tag} from "antd";
import dayjs from "dayjs";
import images from "../../../assets/images";
import {apiError, handleRequest} from "../../../utils";
import {dashboardApi} from "../../../api";
import {Image, FontAwesomeIcon} from "../../../components";

const cn = className.bind(style);

function DashboardPersonnel({user, fullTime}) {

	const [dashboardData, setDashboardData] = useState({
		total              : 0,
		groupTotal         : 0,
		newUser            : 0,
		outUser            : 0,
		formPending        : 0,
		birthdayList       : [],
		probationExpiring  : [],
		contractExpiring   : [],
	});

	useEffect(() => {
		fetchDashboardData().then()
	}, [user]);

	const fetchDashboardData = useCallback(async () => {
		const [
			countResponse,
			birthdayResponse,
			probationExpiringResponse,
			contractExpiringResponse,
		] = await Promise.all([
			handleRequest(dashboardApi.personnelCount()),
			handleRequest(dashboardApi.personnelBirthday()),
			handleRequest(dashboardApi.personnelProbationExpiring()),
			handleRequest(dashboardApi.personnelContractExpiring()),
		]);

		let [countErr, countData] = countResponse;
		let countMsg = apiError(`Load danh sách nhân viên kỹ thuật thất bại`, countErr, countData);
		if (!countMsg) {
			setDashboardData((prevState) => ({
				...prevState,
				total: countData.data.total,
				groupTotal: countData.data.groupTotal,
				newUser: countData.data.newUser,
				outUser: countData.data.outUser,
			}));
		}

		let [birthdayErr, birthdayData] = birthdayResponse;
		let birthdayMsg = apiError(`Load danh sách nhân viên kỹ thuật thất bại`, birthdayErr, birthdayData);
		if (!birthdayMsg) {
			setDashboardData((prevState) => ({
				...prevState,
				birthdayList: birthdayData.data,
			}));
		}

		let [probExpErr, probExpData] = probationExpiringResponse;
		if (!probExpErr && probExpData?.data) {
			setDashboardData((prevState) => ({ ...prevState, probationExpiring: probExpData.data }));
		}

		let [contractExpErr, contractExpData] = contractExpiringResponse;
		if (!contractExpErr && contractExpData?.data) {
			setDashboardData((prevState) => ({ ...prevState, contractExpiring: contractExpData.data }));
		}

	}, [])

	return (
		<div className={cn('dashboard')}>
			<div className={cn('sidebar')}>
				<SidebarAccount user={user} />
			</div>
			<div className={cn('content')}>
				<ContentHeader user={user} fullTime={fullTime} />
				<Row gutter={20}>
					<Col span={6}>
						<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(245,158,11,0.15)', background: '#fff'}}>
							<DashboardWidgetHeader
								icon="fa-light fa-cake-candles"
								title="Sinh nhật trong tháng"
								gradient="linear-gradient(135deg, #f59e0b 0%, #fbbf24 60%, #fde68a 100%)"
								badge={dashboardData.birthdayList.length > 0 ? `${dashboardData.birthdayList.length} người` : null}
							/>
							<div style={{padding: '12px 18px'}}>
								{dashboardData.birthdayList.length === 0 && (
									<div style={{textAlign: 'center', padding: '20px 0', color: '#94a3b8'}}>
										<FontAwesomeIcon icon="fa-light fa-cake-candles" style={{fontSize: 26, display: 'block', marginBottom: 6}} />
										<span style={{fontSize: 12}}>Không có sinh nhật trong tháng</span>
									</div>
								)}
								{dashboardData.birthdayList.map((item, index) => {
									const bd      = item.birthday ? dayjs.unix(item.birthday) : null;
									const isToday = bd && bd.date() === dayjs().date() && bd.month() === dayjs().month();
									const isLast  = index === dashboardData.birthdayList.length - 1;
									return (
										<div key={`birthday-${item.id}`} style={{
											display: 'flex', gap: 10, alignItems: 'center',
											paddingBottom: isLast ? 4 : 12, marginBottom: isLast ? 0 : 12,
											borderBottom: isLast ? 'none' : '1px dashed #e2e8f0',
											...(isToday && {background: '#fff7ed', borderRadius: 10, padding: '8px 10px', margin: '0 -10px', borderBottom: isLast ? 'none' : '1px dashed #e2e8f0'}),
										}}>
											<div className="avatar" style={{width: 40, height: 40, flexShrink: 0}}><Image src={item.avatar} /></div>
											<div style={{flex: 1, minWidth: 0}}>
												<b style={{fontSize: 13, color: '#1e293b', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{item.firstname} {item.lastname}</b>
												<p style={{fontSize: 11, color: '#64748b', margin: 0}}>{item.username}</p>
											</div>
											<div style={{textAlign: 'right', flexShrink: 0}}>
												{isToday && <Tag color="volcano" style={{fontSize: 10, margin: '0 0 2px', lineHeight: '18px'}}>Hôm nay</Tag>}
												<div style={{fontSize: 12, fontWeight: 600, color: '#f59e0b'}}>
													<FontAwesomeIcon icon="fa-light fa-gift" style={{marginRight: 4}} />{bd ? bd.format('DD/MM') : '—'}
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</Col>
					<Col span={17}>
						<div className={'d-flex gap-1 flex-wrap'}>
							<CardMoney image={images.dashboard06} heading={'Tổng nhân viên'} number1={dashboardData.total}/>
							<CardMoney image={images.dashboard06} heading={'Nhóm kinh doanh'} number1={dashboardData.groupTotal}/>
							<CardMoney image={images.dashboard06} heading={'Nhân viên mới'} number1={dashboardData.newUser}/>
							<CardMoney image={images.dashboard06} heading={'Xin nghỉ phép'} number1={dashboardData.formPending}/>
						</div>
						<TrainingScheduleWeek />
						<Row gutter={20} style={{marginTop: 20}}>
							<Col span={12}>
								<EvaluationFailedWidget
									type="3day"
									title="Chưa đạt doanh số 3 ngày"
									icon="fa-light fa-gauge-low"
									gradient="linear-gradient(135deg, #b91c1c 0%, #dc2626 60%, #ef4444 100%)"
								/>
							</Col>
							<Col span={12}>
								<EvaluationFailedWidget
									type="7day"
									title="Chưa đạt doanh số 7 ngày"
									icon="fa-light fa-gauge"
									gradient="linear-gradient(135deg, #b45309 0%, #e47d0a 60%, #f59e0b 100%)"
								/>
							</Col>
						</Row>
						<Row gutter={20} style={{marginTop: 20}}>
							<Col span={12}>
								<ExpiringListWidget
									title="Hết hạn thử việc"
									icon="fa-light fa-user-clock"
									gradient="linear-gradient(135deg, #0369a1 0%, #0284c7 60%, #38bdf8 100%)"
									items={dashboardData.probationExpiring}
									endTimeKey="phaseEndTime"
									renderTag={(item) => item.phaseRole === 'internship' ? 'Thực tập' : 'Thử việc'}
									tagColor={(item) => item.phaseRole === 'internship' ? 'blue' : 'cyan'}
									emptyText="Không có nhân viên hết hạn thử việc trong 6 ngày tới"
								/>
							</Col>
							<Col span={12}>
								<ExpiringListWidget
									title="Cần ký lại hợp đồng"
									icon="fa-light fa-file-contract"
									gradient="linear-gradient(135deg, #be123c 0%, #e11d48 60%, #fb7185 100%)"
									items={dashboardData.contractExpiring}
									endTimeKey="contractEnd"
									renderTag={() => 'HĐ 1 năm'}
									tagColor={() => 'red'}
									emptyText="Không có nhân viên cần ký lại hợp đồng trong 6 ngày tới"
								/>
							</Col>
						</Row>
					</Col>
				</Row>

			</div>
		</div>
	)
}

export default memo(DashboardPersonnel);
